import * as React from 'react'
import Box from '@mui/material/Box'
import Drawer from '@mui/material/Drawer'
import { useTheme } from '@mui/material/styles'
import IconButton from '@mui/material/IconButton'
import { MenuOpenRounded, MenuRounded } from '@mui/icons-material'
import { NavigationList } from './NavigationList'
import { HeaderButtons } from './HeaderButtons'

interface Props {
  onChangeLanguage: VoidFunction
  toggleDrawer: (newValue: boolean) => void
}

export const HeaderDrawer: React.FC<Props> = ({ onChangeLanguage, toggleDrawer }) => {
  const [isOpen, setIsOpen] = React.useState(false)
  const theme = useTheme()

  const toggleDrawerState = () => (event: React.KeyboardEvent | React.MouseEvent) => {
    if (
      event.type === 'keydown' &&
      ((event as React.KeyboardEvent).key === 'Tab' || (event as React.KeyboardEvent).key === 'Shift')
    ) {
      return
    }

    setIsOpen((prev) => !prev)
  }

  const closeDrawer = () => {
    setIsOpen(false)
  }

  React.useEffect(() => {
    toggleDrawer(isOpen)
  }, [isOpen])

  const content = () => (
    <Box
      sx={{
        height: 'calc(100% - 4.5em)',
        boxShadow: 'none',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        padding: '1em 0',
        position: 'absolute',
        width: '100%',
        top: '4.5rem',
      }}
      role='presentation'
    >
      <NavigationList
        onLinkClick={() => {
          onChangeLanguage()
          closeDrawer()
        }}
      />
      <HeaderButtons
        onChangeLanguage={() => {
          onChangeLanguage()
          closeDrawer()
        }}
      />
    </Box>
  )

  return (
    <>
      <IconButton
        onClick={toggleDrawerState()}
        sx={{ color: theme.palette.primary.main, fontSize: '1.5em', display: { sm: 'none' }, padding: '0' }}
      >
        {isOpen ? <MenuOpenRounded /> : <MenuRounded />}
      </IconButton>
      <Drawer
        keepMounted
        anchor={'right'}
        open={isOpen}
        onClose={toggleDrawerState()}
        sx={{ position: 'unset' }}
        hideBackdrop
        PaperProps={{ sx: { boxShadow: 'none', width: '100%', justifyContent: 'space-between' } }}
        disableRestoreFocus
      >
        {content()}
      </Drawer>
    </>
  )
}
